import React, { useState } from "react";
import { Upload } from "lucide-react";

import { useNavigate } from "react-router-dom";

import FormLayout from "../components/FormLayout";

import { LoadingSpinner } from "../components/ui/loading-spinner.tsx"; // Changed this line to use named import
import { useCreateParent } from "../api/parent/parentQueries.js";

function NewParent() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState({ file: null, preview: "" });
  const [parentId, setParentId] = useState({
    front: { file: null, preview: "" },
    back: { file: null, preview: "" },
  });

  const parentMutation = useCreateParent();

  const handleFileUpload = (e, type) => {
    const file = e.target.files?.[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      if (type === "photo") {
        setPhoto({ file, preview });
      } else if (type === "frontId") {
        setParentId((prev) => ({
          ...prev,
          front: { file, preview },
        }));
      } else {
        setParentId((prev) => ({
          ...prev,
          back: { file, preview },
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const parentData = {
      firstName,
      lastName,
      address,
      phoneNumber: phone,
      email,
    };

    parentMutation.mutate(parentData);
    navigate(-1); // Adjust this route as needed
  };

  return (
    <FormLayout title="Create Parent Profile">
      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label
              htmlFor="firstname"
              className="block text-sm font-medium text-gray-700"
            >
              First Name
            </label>
            <input
              type="text"
              id="firstname"
              name="firstname"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block p-2.5"
              required
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="lastname"
              className="block text-sm font-medium text-gray-700"
            >
              Last Name
            </label>
            <input
              type="text"
              id="lastname"
              name="lastname"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="w-full bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block p-2.5"
              required
            />
          </div>
        </div>

        <div className="space-y-2">
          <label
            htmlFor="address"
            className="block text-sm font-medium text-gray-700"
          >
            Enter Address
          </label>
          <input
            id="address"
            name="address"
            placeholder="No 60, Ogba Lagos"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="w-full bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block p-2.5"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-gray-700"
            >
              Enter Phone No.
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block p-2.5"
              required
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Enter Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block p-2.5"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label
              htmlFor="photo"
              className="block text-sm font-medium text-gray-700"
            >
              Upload Photo
            </label>
            <div className="flex items-center gap-2">
              <input
                name="photo"
                type="file"
                accept="image/*"
                className="hidden"
                id="photo"
                onChange={(e) => handleFileUpload(e, "photo")}
              />
              <label
                htmlFor="photo"
                className="flex items-center gap-2 px-4 py-2 border rounded-md cursor-pointer hover:bg-gray-50"
                style={{ height: "42px" }}
              >
                <Upload className="h-4 w-4" />
                <span>Upload</span>
                <span className="text-sm text-gray-500">(Optional)</span>
              </label>
              {photo.preview && (
                <img
                  src={photo.preview}
                  alt="Preview"
                  className="h-10 w-10 rounded-full object-cover"
                />
              )}
            </div>
          </div>

          <div className="space-y-2">
            <label
              htmlFor="frontId"
              className="block text-sm font-medium text-gray-700"
            >
              Upload Parent Id.
            </label>
            <div className="flex gap-4">
              <div className="flex-1">
                <input
                  name="frontId"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  id="frontId"
                  onChange={(e) => handleFileUpload(e, "frontId")}
                />
                <label
                  htmlFor="frontId"
                  className="flex items-center gap-2 px-4 py-2 border rounded-md cursor-pointer hover:bg-gray-50 w-full justify-center"
                  style={{ height: "42px" }}
                >
                  <Upload className="h-4 w-4" />
                  <span>Front</span>
                </label>
              </div>

              <div className="flex-1">
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  id="backId"
                  onChange={(e) => handleFileUpload(e, "backId")}
                />
                <label
                  htmlFor="backId"
                  className="flex items-center gap-2 px-4 py-2 border rounded-md cursor-pointer hover:bg-gray-50 w-full justify-center"
                  style={{ height: "42px" }}
                >
                  <Upload className="h-4 w-4" />
                  <span>Back</span>
                </label>
              </div>
            </div>
            <div className="mt-2 flex gap-4">
              {parentId.front.preview && (
                <img
                  src={parentId.front.preview}
                  alt="Front ID Preview"
                  className="h-20 w-32 object-cover rounded-md"
                />
              )}
              {parentId.back.preview && (
                <img
                  src={parentId.back.preview}
                  alt="Back ID Preview"
                  className="h-20 w-32 object-cover rounded-md"
                />
              )}
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={parentMutation.isPending}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {parentMutation.isPending ? (
            <>
              <LoadingSpinner size="sm" className="mr-2" />
              Creating...
            </>
          ) : (
            "Create Parent"
          )}
        </button>
      </form>
    </FormLayout>
  );
}

export default NewParent;
